import styled from 'styled-components';

export const OptionsMenuContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== '$isHidden' && prop !== '$isOpen',
})<{ $isHidden?: boolean; $isOpen?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${({ $isHidden: isHidden }) => (isHidden ? 0 : 1)};
  z-index: ${({ $isOpen }) => ($isOpen ? 1000 : 1)};

  svg {
    cursor: pointer;
  }
`;

export const Menu = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== '$placement',
})<{ $isHidden: boolean; $placement?: 'side' | 'bottom-end' }>`
  min-width: 250px;
  position: absolute;
  left: ${({ $placement }) => ($placement === 'bottom-end' ? 'auto' : 'calc(100% + 12px)')};
  right: ${({ $placement }) => ($placement === 'bottom-end' ? 0 : 'auto')};
  top: ${({ $placement }) => ($placement === 'bottom-end' ? 'calc(100% + 8px)' : 0)};
  opacity: ${({ $isHidden: isHidden }) => (isHidden ? 0 : 1)};
  transform: ${({ $isHidden: isHidden, $placement }) => {
    if ($placement === 'bottom-end') {
      return isHidden ? 'translateY(-6px)' : 'translateY(0)';
    }

    return isHidden ? 'translate(-10px, -10%)' : 'translate(0, -10%)';
  }};
  transition:
    opacity 0.3s,
    transform 0.3s;
  pointer-events: ${({ $isHidden: isHidden }) => (isHidden ? 'none' : 'auto')};
  z-index: 99;
  background-color: ${({ theme }) => theme.colors.panelBackground};
  border-radius: ${({ theme }) => theme.borderRadius.normal};
  box-shadow: ${({ theme }) => theme.shadow.light};
  border: 1px solid ${({ theme }) => theme.colors.tableBorder};

  @media (max-width: 768px) {
    right: -12px;
    left: unset;
    top: 100%;
    transform: ${({ $isHidden: isHidden }) => (isHidden ? 'translate(0, 0)' : 'translate(0, 5px)')};
  }
`;

export const MenuItem = styled.div<{ $disabled?: boolean }>`
  width: 100%;
  padding: 8px 16px;
  cursor: pointer;
  font-size: ${({ theme }) => theme.fontSizes.medium};
  &:hover {
    background-color: ${({ theme }) => theme.colors.insetPanelBackground};
  }
  &:first-child {
    border-top-left-radius: ${({ theme }) => theme.borderRadius.normal};
    border-top-right-radius: ${({ theme }) => theme.borderRadius.normal};
  }
  &:last-child {
    border-bottom-left-radius: ${({ theme }) => theme.borderRadius.normal};
    border-bottom-right-radius: ${({ theme }) => theme.borderRadius.normal};
  }

  ${({ $disabled }) =>
    $disabled &&
    `
      opacity: 0.5;
      user-select: none;
      pointer-events: none;
    `}
`;
